module.exports = __webpack_public_path__ + "app/modals/broadcast-speed-warning-modal.view.html";